import { FC } from 'react'
import { useTheme } from '@emotion/react'

// icons
import { icons } from '@/assets'
// hooks
import { useAppDispatch } from '@/hooks'
// features
import { postClosePostBlockModal } from '@/features'
// components
import { CardHeaderMobile, ModalCardTitle, ModalCardSubtitle, Error } from '@/components'

// components
import { PostBlockForm } from './components'
// styles
import { styles } from './styles'

type PostBlockCardProps = {}

export const PostBlockCard: FC<PostBlockCardProps> = () => {
  const theme = useTheme()

  const dispatch = useAppDispatch()
  const postBlockError = ''

  return (
    <div
      css={styles(theme).card.main}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      {/* mobile header */}
      <div css={styles(theme).card.header}>
        <CardHeaderMobile onCloseClick={() => dispatch(postClosePostBlockModal())} />
      </div>

      {/* title */}
      <div css={styles(theme).card.title}>
        <ModalCardTitle text="Block Post" icon={icons.AlertTriangle} />
      </div>

      {/* subtitle */}
      <div css={styles(theme).card.subtitle}>
        <ModalCardSubtitle text="Are you sure you want to block this post?" />
      </div>

      <div css={styles(theme).card.content.main}>
        {/* form */}
        <div css={styles(theme).card.content.form}>
          <PostBlockForm />
        </div>

        <div css={styles(theme).card.content.error}>
          <Error error={postBlockError} />
        </div>
      </div>
    </div>
  )
}

PostBlockCard.propTypes = {}
